import Header from "../home/header"
import Androidheader from "./androidheader"
import AndroidDescription from "./androidDescription"
import Technologies from "../home/technologies"
import HowwebuildProject from "../home/howwebuildProject"
import Contactnow from "../home/contactnow"
import Footer from "../home/footer" 
import Dreamcontact from "../home/dreamcontact"
const androidiospage=()=>{
    return(
        <>
            <Header/>
            <Androidheader/>
            <AndroidDescription/>
            <Technologies/>
            <HowwebuildProject/>
            <Dreamcontact/>
            <Footer/>
        </>
    )
}

export default androidiospage